import { type ProductDetailsPageState } from "~/features/productDetails/redux/productDetailsTypes";
import { PDP_SELECT_PRICE_REFERENCE, type PdpActions } from "~/features/productDetails/redux/actions";
import { type Reducer } from "redux";

export const initialProductDetailsPageState: ProductDetailsPageState = {
  selectedPriceReference: "",
};

export const productDetailsPageReducer: Reducer<ProductDetailsPageState, PdpActions> = (
  state = initialProductDetailsPageState,
  action,
): ProductDetailsPageState => {
  switch (action.type) {
    case PDP_SELECT_PRICE_REFERENCE: {
      return {
        ...state,
        selectedPriceReference: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
